import CigeCpe from '../../components/cigecpe/cigecpe';

const CigeCpePage = () => {
  return <CigeCpe />;
};

export default CigeCpePage;
